import { useEffect, useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
    Box,
    CircularProgress,
} from "@mui/material";
import { User } from "../../../types/userTypes";
import SuperAdminCompanyService from './../../../service/superadmin/companyService';

interface ViewUserProps {
    open: boolean;
    onClose: () => void;
    user: User | null;
    loading: boolean;
}

const ViewUser: React.FC<ViewUserProps> = ({ open, onClose, user, loading }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>User Details</DialogTitle>
            <DialogContent>
                {loading ? (
                    <CircularProgress />
                ) : user ? (
                    <Box>
                        <Typography><strong>Username:</strong> {user.username}</Typography>
                        <Typography><strong>Email:</strong> {user.email}</Typography>
                        <Typography><strong>Phone:</strong> {user.phone}</Typography>
                        <Typography><strong>Address:</strong> {user.address}</Typography>
                        <Typography><strong>Role:</strong> {user.role}</Typography>
                        <Typography><strong>Status:</strong> {user.status === "1" ? "Active" : "Inactive"}</Typography>
                        <Typography><strong>Company Admin:</strong> {user.is_company_admin === "1" ? "Yes" : "No"}</Typography>
                        <Typography>
                            <strong>Created At:</strong>{" "}
                            {new Date(user.created_at).toLocaleString(undefined, {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                            })}
                        </Typography>

                    </Box>
                ) : (
                    <Typography>No user data found.</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewUser;
